const actions = {
  fetch: 'FETCH::EMBEDDED_REPORT',
  fetching: 'FETCHING::EMBEDDED_REPORT',
  fetchSucceeded: 'FETCH::SUCCEEDED',
  fetchFailed: 'FETCH::FAILED',
  clear: 'CLEAR::EMBEDDED_REPORT',
  viewed: 'VIEWED::EMBEDDED_REPORT',
  set: 'SET::EMBEDDED_REPORT',
  get: 'GET::EMBEDDED_REPORT'
}

export const fetchEmbeddedReport = name => ({ type: actions.fetch, fetchState: 'pending', reportName: name })
export const fetchEmbeddedReportSucceeded = state => ({ type: actions.fetchSucceeded, fetchState: 'succeeded', report: state })
export const fetchEmbeddedReportFailed = state => ({ type: actions.fetchFailed, fetchState: 'failed', error: state })
export const fetchingEmbeddedReport = () => ({ type: actions.fetching })

export const setEmbeddedReportName = state => ({ type: actions.set, embeddedReportName: state })
export const getEmbeddedReportName = state => state.embeddedReportName

export default actions



// WEBPACK FOOTER //
// ./src/store/report-viewer/actions.js